import { SafetyCertificateOutlined } from "@ant-design/icons"
import { Tag, Tooltip } from "antd"
import { useTranslation } from "react-i18next"

export const SignedRecordTag = ({
  className = "!m-0 shrink-0"
}: {
  className?: string
}) => {
  const { t } = useTranslation()
  return (
    <Tooltip title={t("files.signedRecordTooltip")}>
      <Tag
        color="green"
        icon={<SafetyCertificateOutlined />}
        className={className}
      >
        {t("files.signedRecord")}
      </Tag>
    </Tooltip>
  )
}
